// extracted by mini-css-extract-plugin
export var divider = "_o5-0";
export var systemMessage = "_o5-1";
export var systemMessageWrapper = "_o5-2";